import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Box, Button, Typography } from '@mui/material';
import { z } from 'zod';
import TextField from '../../components/TextField';

const schema = z.object({
  description: z.string().min(1, 'Description is required'),
  url: z.string().min(1, 'URL is required'),
  // logo: z.string(),
});

const DownloadDetailsForm = ({ downloadData = undefined, onConfirm }) => {
  const methods = useForm({
    resolver: zodResolver(schema),
    defaultValues: downloadData,
  });

  const { handleSubmit } = methods;

  const onSubmit = (data) => {
    onConfirm(data);
  };

  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      minHeight='100%'
      paddingX={2}
      paddingY={4}
    >
      <Typography variant='h4' gutterBottom>
        {!downloadData ? 'Create new download item' : 'Edit download item'}
      </Typography>

      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <TextField label='Description' name='description' />
          <TextField label='URL' name='url' />
          {/* <TextField label='Logo' name='logo' /> */}

          <Box mt={3} mb={2}>
            <Button type='submit' variant='contained' color='primary' fullWidth>
              Add document
            </Button>
          </Box>
        </form>
      </FormProvider>
    </Box>
  );
};

export default DownloadDetailsForm;
